var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6246 15.1271C11.6596 15.3604 11.5721 15.6093 11.3709 15.7726C11.29 15.8447 11.1938 15.9019 11.088 15.9409C10.9822 15.9799 10.8687 16 10.7541 16C10.6396 16 10.5261 15.9799 10.4203 15.9409C10.3144 15.9019 10.2183 15.8447 10.1373 15.7726L6.62908 12.6541C6.53371 12.5712 6.4612 12.4697 6.41719 12.3578C6.37318 12.2458 6.35887 12.1263 6.37536 12.0086V8.02696L2.18469 3.25983C2.04262 3.09771 1.97851 2.89219 2.00638 2.68819C2.03425 2.48418 2.15183 2.29827 2.33342 2.17109C2.49965 2.06221 2.68337 2 2.87585 2H15.1242C15.3166 2 15.5004 2.06221 15.6666 2.17109C15.8482 2.29827 15.9657 2.48418 15.9936 2.68819C16.0215 2.89219 15.9574 3.09771 15.8153 3.25983L11.6246 8.02696V15.1271ZM4.6606 3.55534L8.12512 7.49037V11.7831L9.87488 13.3385V7.48259L13.3394 3.55534H4.6606Z",
    fill: "#1677FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f8f0abdddfdacc5f77b9e97c74e22907.svg";
export { ForwardRef as ReactComponent };